<style>
  .authorizeUserAdd .ego-copy_b{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    font-size: 21px;
    cursor: pointer;
  }
  .authorizeUserAdd .btnKey{
    position: absolute;
    right: -88px;
    top: 50%;
    transform: translateY(-50%);
  }
  /* .authorizeUserAdd .el-date-editor.el-input{
    width: 100%;
  } */
</style>
<template>
<div class="authorizeUserAdd">
  <el-card v-loading='loading'>
    <div slot="header">
      <el-button type="primary" @click="goBack" icon="arrow-left" size="small">返回</el-button>
      <template v-if="opertionType !== 'add'">
        <el-button type="primary" :disabled="opertionType === 'edit'" @click="toEditPage" icon="edit">编辑</el-button>
        <el-button type="danger" @click="deleteInfo" :disabled="opertionType === 'edit'" icon="delete">删除</el-button>
      </template>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="用户管理" name="first">
          <el-form ref="userForm" :model="userData" :rules="rules" label-width="105px">
            <el-row>
              <el-col :xs="20" :sm="18" :md="15" :lg="13">
                <el-form-item label="用户AppID" prop="AppID" >
                  <span v-if="opertionType !== 'add'">{{userData.AppID}}</span>
                  <el-input v-model="userData.AppID" :maxlength = 50 size="small" v-else></el-input>
                  <el-button type="primary" class="btnKey" size="small" @click="generateID">生成ID</el-button>
                </el-form-item>
                <el-form-item label="用户AppKey" prop="AppKey">
                  <span v-show="opertionType === 'detail'">{{userData.AppKey}}</span>
                  <template v-if="opertionType !== 'detail'">
                  <el-input v-model="userData.AppKey" size="small" disabled></el-input>
                  <el-button type="primary" class="btnKey" size="small" @click="generateKey">生成key</el-button>
                  </template>
                  <el-tooltip placement="top">
                    <div slot="content">{{tips}}</div>
                    <i id = 'AppKeyContent' class="egofont ego-copy_b" @mouseenter="changeTips"></i>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="用户名称" prop="AppCustName">
                  <span v-if="opertionType === 'detail'">{{userData.AppCustName}}</span>
                  <el-input v-model="userData.AppCustName" :maxlength = 30 size="small" v-else></el-input>
                </el-form-item>
                <el-form-item label="授权有效期" prop="AppExpireDate">
                  <span v-if="opertionType === 'detail'">{{userData.AppExpireDate | excludeTime}}</span>
                  <el-date-picker
                    v-else
                    v-model="effectDate"
                    type="date"
                    size="small"
                    :clearable="false"
                    :editable="false"
                    @change='settime'
                    :picker-options="pickerOptions0">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="用户状态" prop="Tag">
                    <el-radio-group v-model="userData.Tag" :disabled="opertionType === 'detail'">
                      <el-radio :label = 0>正常</el-radio>
                      <el-radio :label = 1>禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注" prop="Memo">
                  <span v-if="opertionType === 'detail'">{{userData.Memo}}</span>
                  <el-input type="textarea" :maxlength = 120 v-model="userData.Memo" :rows="6" v-else></el-input>
                </el-form-item>
                <div style="text-align: center;">
                  <el-button type="primary" @click="saveAddInfo" v-if="opertionType !== 'detail'">保存</el-button>
                  <el-button type="primary" @click="cancelEdit" v-if="opertionType === 'edit'">取消</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
      </el-tab-pane>
        <el-tab-pane label="权限设置" name="second" :disabled="opertionType === 'add'">
          <show-table
            ref = 'showtable'
            @delItem = 'delAuthorize'
            :queryobj = 'queryObj'
            :queryparam = 'queryParam'
            :showopertbtn = 'showType'>
            <el-button slot='add' type="primary" icon="plus" size="small" @click="addAuthorize">增加权限</el-button>
          </show-table>
        </el-tab-pane>
    </el-tabs>
  <queryuser
    ref="queryuserDialog"
    :appid = 'rowDatas.AppID'
    @passtabledata = 'passTableData'
    :dialog-table-visible.sync="dialogTableVisible"></queryuser>
  </el-card>
</div>
</template>
<script>
  import util from '../../../util'
  var md5Util = require('../../../md5.js');
  import queryUser from './queryUser.vue'
  import {DataObjectUpdate, bizQueryBatchExecute} from '../../../vuex/actions'
  import {sessionUser} from '../../../vuex/getters'
	export default {
    props: ['operation', 'rowdatas'],
    vuex: {
      getters: {
        sessionUser
      },
      actions: {
        DataObjectUpdate,
        bizQueryBatchExecute
      }
    },
    data() {
      return {
        loading: false,
        tips: '复制AppKey',
        rowDatas: this.rowdatas,
        effectDate: '',
        opertionType: this.operation,
        activeName: 'first',
        dialogTableVisible: false,
        isDetails: this.isdetails,
        queryObj: {
          queryName: 'GetUserServer',
          AppID: this.rowdatas.AppID,
          ServerID: '',
          displayLabel: '服务ID/名称查询',
        },
        queryParam: 'ServerID',
        showType: {
          edit: false,
          del: true,
          defined: false,
        },
        userData: {
          AppID: '',
          AppKey: '',
          AppCustName: '',
          AppExpireDate: '',
          Tag: 0,
          Memo: '',
        },
        rules: {
          AppID: [
            {required: true, message: '请输入AppID', trigger: 'blur'},
          ],
          AppKey: [
            {required: true, message: '请输入用户AppKey', trigger: 'blur'}
          ],
          AppCustName: [
            {required: true, message: '请输入用户名称', trigger: 'blur'},
          ],
         AppExpireDate: [
           {required: true, message: '请输入授权时效日期', trigger: 'blur'},
         ],
//          Tag: [
//            {required: true, message: '请选择用户状态', trigger: 'blur'},
//          ],
        },
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      };
    },
    components: {
      "queryuser": queryUser,
    },
    watch:{
      opertionType:function (val) {
        console.log("watch val:",val);
        this.$emit('navagationtype', val);
      }
    },
    mounted() {
      let self = this
      var clipboard = new Clipboard('#AppKeyContent', {
        // 点击copy按钮，直接通过text直接返回复印的内容
        text: function() {
          return self.userData.AppKey;
        }
      });
      clipboard.on('success', function(e) {
        self.tips = '已复制到剪切板！'
      });

      clipboard.on('error', function(e) {
        console.log(e);
      });
      if (this.opertionType === 'detail') {
        this.userData = util.deepCopy(this.rowDatas, {})
        this.loadParentData()
      }
    },
    filters: {
      excludeTime: function (date) {
        return date.split(' ')[0]
      }
    },
    methods: {
      passTableData (data) {
        console.log(data)
        let serverData = formatData(data)
        let params = {
          dataList_0: [{
            //请求必填参数
            BusinessID: 'OAuthUserModify',
            OperName: this.sessionUser.userName,
            Operator: this.sessionUser.userId,
            LastUpdateTime: this.userData.LastUpdateTime || '',
            Old_LastUpdateTime: this.userData.LastUpdateTime || '',
            ModuleID: this.$route.params.moduleID || '399302',
            ActionNO: 'OAuthUserModify',
            PaperNO: '',
            //输入参数
            AppID: this.userData.AppID,
            AppKey: this.userData.AppKey,
            AppCustName: this.userData.AppCustName,
            AppExpireDate: this.userData.AppExpireDate,
            Tag: this.userData.Tag,
            Memo: this.userData.Memo,
          }],
          dataList_1: serverData
        }
        this.bizQueryBatchExecute(params, (res) => {
          if(res.isValid && res.data.isValid){
            this.loadParentData()
            if(this.dialogTableVisible === true){
              this.$refs.queryuserDialog.loadServerApi()
            }else{
              util.success(this, '新增接口服务成功')
              this.$refs['showtable'].searchData()
            }
          }else{
            util.error(this, '新增接口服务失败')
          }
        })
      },
      changeTips () {
        this.tips = '复制AppKey'
      },
      settime (val) {
        console.log(this.effectDate)
        this.userData.AppExpireDate = val + ' 00:00:00'
        console.log(this.userData.AppExpireDate)
      },
      generateID(){
        let msg = new Date().getTime()+"123"
        console.log(msg)
        this.userData.AppID = md5Util.md5(msg)
      },
      //生成md5
      generateKey () {
        let msg = Date.now() + this.userData.AppID
        this.userData.AppKey = md5Util.md5(msg)
      },
      delAuthorize (data) {
        let params = {
          dataList_0: [{
            //请求必填参数
            BusinessID: 'OAuthUserModify',
            OperName: this.sessionUser.userName,
            Operator: this.sessionUser.userId,
            LastUpdateTime: this.userData.LastUpdateTime || '',
            Old_LastUpdateTime: this.userData.LastUpdateTime || '',
            ModuleID: this.$route.params.moduleID || '399302',
            ActionNO: 'OAuthUserModify',
            PaperNO: '',
            //输入参数
            AppID: this.userData.AppID,
            AppKey: this.userData.AppKey,
            AppCustName: this.userData.AppCustName,
            AppExpireDate: this.userData.AppExpireDate,
            Tag: this.userData.Tag,
            Memo: this.userData.Memo,
          }],
          dataList_1: [{
            ServerID: data.ServerID,
            UpdateFlag: 'D',
          }]
        }
        this.$confirm(`确认删除服务ID${data.ServerID}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loadParentData()
            this.loading = false
            if(res.isValid && res.data.isValid){
              util.success(this, `服务ID${data.ServerID}删除成功`)
              this.$refs['showtable'].searchData()
            }
          })
        }).catch(() => {
        })
      },
      loadParentData() {
        let params = {
          objectName: 'OAuthUser',
          AppID: this.userData.AppID,
          PaperNO: '',
        }
        this.DataObjectUpdate(params, (res) => {
          if(res.isValid && res.data.isValid){
            this.userData = res.data.dataList.dataList_0[0]
            this.effectDate = new Date(this.userData.AppExpireDate)
          }
        })
      },
      addAuthorize() {
        this.dialogTableVisible = true;
      },
      handleClick(tab, event) {console.log(tab)
        if(tab.name === 'second' && tab.disabled === true){
          util.waring(this, '请先保存用户信息')
        }
      },
      goBack() {
        this.$emit('goback')
      },
      deleteInfo() {
        let params = {
          dataList_0: [{
            //请求必填参数
            BusinessID: 'OAuthUserDel',
            OperName: this.sessionUser.userName,
            Operator: this.sessionUser.userId,
            LastUpdateTime: this.userData.LastUpdateTime,
            Old_LastUpdateTime: this.userData.LastUpdateTime,
            ModuleID: this.$route.params.moduleID || '299303',
            ActionNO: 'OAuthUserDel',
            PaperNO: '',
            //输入参数
            AppID:this.userData.AppID,
          }]
        }
        this.$confirm(`确认要删除当前授权用户${this.userData.AppID}吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if(res.isValid && res.data.isValid){
              util.success(this, `用户${this.userData.AppID}删除成功`)
              this.goBack()
            }
          })
        }).catch(() => {})
      },
      toEditPage() {
        this.opertionType = 'edit';
      },
      cancelEdit() {
        this.$confirm('取消后编辑信息将丢失，确认取消？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loadParentData()
          this.opertionType = 'detail'
        }).catch(() => {})
      },
      saveAddInfo() {
        let type, msg
        if (this.opertionType === 'edit'){
          type = 'OAuthUserModify'
          msg = '修改'
        }else{
          type = 'OAuthUserAdd'
          msg = '新增'
        }
        if (this.validate()) {
          let params = {
            dataList_0: [{
              //请求必填参数
              BusinessID: type,
              OperName: this.sessionUser.userName,
              Operator: this.sessionUser.userId,
              LastUpdateTime: this.userData.LastUpdateTime || '',
              Old_LastUpdateTime: this.userData.LastUpdateTime || '',
              ModuleID: this.$route.params.moduleID,
              ActionNO: type,
              PaperNO: '',
              //输入参数
              AppID: this.userData.AppID,
              AppKey: this.userData.AppKey,
              AppCustName: this.userData.AppCustName,
              AppExpireDate: this.userData.AppExpireDate,
              Tag: this.userData.Tag,
              Memo: this.userData.Memo,
            }]
          }
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if(res.isValid && res.data.isValid){
              if (this.opertionType === 'edit'){
                util.success(this, `用户${params.dataList_0[0].AppID}${msg}成功`)
              }else{
                util.success(this, `用户${params.dataList_0[0].AppID}${msg}成功`)
              }
              this.opertionType = 'detail'
              this.loadParentData()
              this.rowDatas.AppID = this.userData.AppID
              this.queryObj.AppID = this.userData.AppID
            }
          })
        }
      },
      validate() {
        let isValidate
        this.$refs['userForm'].validate((valid) => {
          if (valid) {
            isValidate = true
          } else {
            console.log('error submit!!');
            isValidate = false
            return false;
          }
        })
        return isValidate
      },
    },
  }
  function formatData(data) {
    let arr = []
    data.forEach(function(el){
      let obj = {}
      obj.ServerID = el.ServerID
      obj.UpdateFlag = 'I'
      arr.push(obj)
    })
    return arr
  }
</script>




// WEBPACK FOOTER //
// authorizeUserAdd.vue?71c652bc